import { useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";

const PatientMapRosterTableOpport = ({
  data = [],
  searchTerm = "",
  loading,
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  onSelectPatient
}) => {
  const rows = useMemo(() => {
    return data;
  }, [data, searchTerm]);
  const columns = useMemo(() => [
    { field: "Update", headerName: "Update", flex: 3, filterable: false },
    { field: "InsuranceStatus", headerName: "Insurance Status", flex: 3, filterable: false },
    { field: "MemberFullName", headerName: "Member Full Name", flex: 3, filterable: false },
    { field: "DOB", headerName: "DOB", flex: 3, filterable: false },
    { field: "MemberPhoneNumber", headerName: "Member Phone Number", flex: 3, filterable: false },
    { field: "PCPFullName", headerName: "PCP Full Name", flex: 3, filterable: false },
    { field: "OfficeLocation", headerName: "Office Location", flex: 3, filterable: false },
    { field: "Status", headerName: "Status", flex: 3, filterable: false },
    { field: "WelcomeCampaignOptions", headerName: "Welcome Campaign Options", flex: 3, filterable: false },
    {
      field: "ReleatedComments",
      headerName: "Releated Comments",
      flex: 3,
      filterable: false,
      renderCell: (params) => {
        const count = params.row.ReleatedComments?.length ?? 0;
        return `Audit Charts (${count})`;
      }
    },
    { field: "StaffName", headerName: "Staff Name", flex: 3, filterable: false }
  ], [onSelectPatient]);

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <div style={{ minWidth: "1500px" }}>
        <DataGrid
          getRowId={(row) => `${row.MemberID}`}
          rows={rows}
          columns={columns}
          rowCount={total}
          paginationMode="server"
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page);
            setPageSize(pageSize);
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          disableColumnFilter
          disableColumnSelector
          loading={loading}
          onRowClick={(params) => onSelectPatient(params.row)}
        />
      </div>
    </div>
  );
};

export default PatientMapRosterTableOpport;
